import React__default from 'react';

const GoogleTagManagerNoScript = ({ gtmId }) => (React__default.createElement("noscript", null,
    React__default.createElement("iframe", { src: `https://www.googletagmanager.com/ns.html?id=${gtmId}`, height: "0", width: "0", style: { display: 'none', visibility: 'hidden' } })));

export { GoogleTagManagerNoScript as default };
